import React, { Component } from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import FlexView from "react-flexview";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../modules/SimpleDDL";
import { contructQueryParam, fetchDataAsync, hasNilOrEmpty } from "../../../Services/Utils";
import Api from "../../../Services/Api";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import * as R from "ramda";
import { mapToObjectDDL } from "../../common/mapper";
import { HttpStatus } from "../../common/Constants";
import { tableColumnsHO, tableColumnsDetail } from "./config";

class FakturJualDetailDataInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchKey: null,
            searchValue: null,
            dataTable1: [],
            dataTable2: [],
            tableConfigHo: [],
            tableConfigDetail: [],
            pagination: {
                count: 10,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        }
    }

    componentDidMount() {
        this.setState({
            tableConfigHo: tableColumnsHO(),
            tableConfigDetail: tableColumnsDetail()
        });
    }

    handleSearchValueChange = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    handleSelect = (rowIndex) => {

    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };



    render() {
        return (
            <>
                <SimpleModal
                    title={this.props.title}
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                                <SimpleInput
                                    type="text"
                                    name="searchValue"
                                    label={"Nama Konsumen"}
                                    value={this.state.searchValue}
                                    onChange={(e) => this.handleSearchValueChange(e.target.name, e.target.value)}
                                />
                                <SimpleButton
                                    text="Cari"
                                    style={{ marginTop: 22 }}
                                    className="margin-bottom-15px"
                                    onClick={this.handleSubmitSearch}
                                />
                            </FlexView>

                            <FlexView style={{ gap: "50px" }}>
                                <SimpleDataTable
                                    data={this.state.dataTable1}
                                    columns={this.state.tableConfigHo}
                                />
                                <SimpleDataTable
                                    data={this.state.dataTable2}
                                    columns={this.state.tableConfigDetail}
                                />
                            </FlexView>
                            <br />
                            <br />
                            <FlexView hAlignContent="right">
                                <SimpleButton
                                    type="button"
                                    text="Proses"
                                    // onClick={() => }
                                />
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(FakturJualDetailDataInput);